import {useAuth} from "../../components/auth/AuthContext";
import {AccountsAPI} from "../../accounts-api/accounts-api";
import {FC, useEffect, useState} from "react";
import {OAuthStore} from "../../components/auth/store";
import {Navigate} from "react-router-dom";
import {useNavigate} from "react-router";
import {FullPageSpinner} from "../../components/loading/Spinner";
import {completeLogin} from "../../domain/login";
import {getWakeletUrl} from "../../env/env";
import {AccountSubdomainStore, toAccountReturnLocation} from "../../components/auth/subdomain";


export const OAuthEndPage: FC = () => {
  const navigate = useNavigate();
  const [postAuthStarted, setPostAuthStarted] = useState<boolean>(false);
  const {user, loading} = useAuth();
  const sessionId = OAuthStore.getSession() || "";

  useEffect(() => {
    if (!user || !sessionId) {
      return;
    }
    setPostAuthStarted(true);
    user.getIdToken()
    .then(idToken => AccountsAPI.setAuthUser(idToken, sessionId))
    .then(res => {
      completeLogin();
      window.location.assign(toAccountReturnLocation(res.location));
    })
    .catch(err => {
      console.error("Problem setting AuthUser", err);
      navigate("/error");
    })
  }, [loading]);

  if (loading) {
    return <FullPageSpinner/>;
  }
  if (!user) {
    return <Navigate to="/login"/>;
  }
  if (postAuthStarted) {
    return <FullPageSpinner />;
  }
  if (!sessionId) {
    console.warn("!sessionId, redirecting to: " + getWakeletUrl());
    window.location.assign(getWakeletUrl());
    return null;
  }
  return null;
};
